import { isToday, isTomorrow, isYesterday } from 'date-fns';
import { formatLocale, getLocale } from 'lib';

function normalizeDate(date, type, t) {
  const dateObj = new Date(date);
  const locale = getLocale();

  switch (type) {
    case 'Hour':
      return formatLocale(dateObj, 'h:mm aa', { locale });

    case 'Days':
      return formatLocale(dateObj, 'MMM dd, iii', { locale });

    case 'DayOfMonth':
      return formatLocale(dateObj, 'MMM do', { locale });

    case 'Weeks':
      return formatLocale(dateObj, 'MMM dd', { locale });

    case 'Months':
      return formatLocale(dateObj, 'MMM, yyyy', { locale });

    case 'Quarters':
      return formatLocale(dateObj, 'QQQ, yyyy', { locale });

    case 'Years':
      return formatLocale(dateObj, 'yyyy', { locale });

    default:
      if (isToday(dateObj)) {
        return `${formatLocale(dateObj, 'h:mm aa', { locale })}`;
      } else if (isYesterday(dateObj)) {
        return `${t('common.yesterday', { locale })}, ${formatLocale(dateObj, 'h:mm aa', { locale })}`;
      } else if (isTomorrow(dateObj)) {
        return `${t ? `${t('common.tomorrow', { locale })}, ` : ''}${formatLocale(dateObj, 'h:mm aa', { locale })}`;
      }

      return `${formatLocale(dateObj, 'MMM dd, h:mm aa')}`;
  }
}

export default normalizeDate;
